/* bcl-facet-recount.js — 2026-06-02 (rev2, robust re-apply)
 * Aligns the SIZE filter badge counts with the in-stock grid.
 *
 * Shopify's native facet count (value.count) counts a product under a size if it
 * HAS that size variant and the product is purchasable in ANY size — so a product
 * whose size-32 variant is sold out (but in stock in other sizes) still inflates
 * the (32) badge. The grid shows only products whose size-32 variant is in stock,
 * so the badge can read (19) while the grid shows 17.
 *
 * Size is a variant OPTION, so /collections/{handle}/products.json carries the
 * per-size availability we need. We recount in-stock-per-size and rewrite the
 * badges. (Colour/fabric/fit are product METAFIELDS, absent from products.json,
 * so they can't be recounted client-side and keep Shopify's count.)
 *
 * The theme's AJAX filter swap re-renders the facet panel back to Shopify's native
 * counts, so we re-apply on: initial load, any DOM change (observer), filter
 * change events, and a few timed retries — all idempotent (write-on-diff) and
 * served from one cached products fetch.
 */
(function () {
  var PARAM = 'filter.v.option.size';
  var CACHE = null;
  var CAPPED = false;
  var MAX_PAGES = 12; // 12 * 250 = 3000 products
  var APPLYING = false;
  var FETCHING = false;

  function handle() {
    var m = location.pathname.match(/\/collections\/([^\/]+)/);
    return m ? m[1] : null;
  }

  // Only bail when a METAFIELD filter (colour/fabric/fit/pattern/neck/style/theme/
  // discount) is active — products.json has no metafields, so a recount would be
  // wrong there. A size filter being active is fine: "how many in stock per size"
  // is collection-wide info.
  function metafieldFilterActive() {
    if (document.querySelector('input[name^="filter.p."]:checked')) return true;
    if (/[?&]filter\.p\./.test(location.search)) return true;
    return false;
  }

  function computeCounts(products) {
    var counts = {};
    products.forEach(function (p) {
      var idx = -1;
      (p.options || []).forEach(function (o, i) { if (/size/i.test(o.name)) idx = i; });
      if (idx < 0) return;
      var key = 'option' + (idx + 1);
      var seen = {};
      (p.variants || []).forEach(function (v) {
        if (!v.available) return;
        var sz = v[key];
        if (sz == null) return;
        sz = String(sz).trim();
        if (seen[sz]) return;
        seen[sz] = 1;
        counts[sz] = (counts[sz] || 0) + 1;
      });
    });
    return counts;
  }

  function apply(counts) {
    APPLYING = true;
    var inputs = document.querySelectorAll('input[name="' + PARAM + '"]');
    Array.prototype.forEach.call(inputs, function (inp) {
      var label = inp.closest('.bcl-filter-check');
      if (!label) return;
      var badge = label.querySelector('.bcl-filter-check__count');
      if (!badge) return;
      var n = counts[String(inp.value).trim()] || 0;
      var want = '(' + n + ')';
      if (badge.textContent !== want) badge.textContent = want;
      if (n === 0 && !inp.checked) { label.classList.add('is-disabled'); inp.disabled = true; }
    });
    APPLYING = false;
  }

  function fetchAll(h) {
    var all = [], page = 1;
    function next() {
      return fetch('/collections/' + h + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var ps = (j && j.products) || [];
          all = all.concat(ps);
          if (ps.length === 250) {
            if (page < MAX_PAGES) { page++; return next(); }
            CAPPED = true;
          }
          return all;
        });
    }
    return next();
  }

  function run() {
    if (!document.querySelector('input[name="' + PARAM + '"]')) return;
    if (metafieldFilterActive()) return;
    if (CACHE) { apply(computeCounts(CACHE)); return; }
    if (CAPPED) return;
    // 2026-06-09 PERF: do NOT crawl products.json (up to 12 pages) until the user opens
    // the filter drawer. On HTTP/1.1 these saturated all 6 connections to basicslife.com
    // and starved product-image loads for 20-30s on mobile. __bclWantCounts is set by the
    // grid's openFilterDrawer(); FETCHING stops the observer/retries from launching several
    // concurrent crawls before CACHE is set.
    if (!window.__bclWantCounts) return;
    if (FETCHING) return;
    var h = handle();
    if (!h || h === 'all') return; // 'all' products.json is the whole store, not the collection
    FETCHING = true;
    fetchAll(h).then(function (ps) {
      FETCHING = false;
      if (CAPPED) return;          // collection too big — incomplete data, leave Shopify's counts
      if (!ps || !ps.length) return; // empty/failed fetch — never zero out the badges
      CACHE = ps;
      apply(computeCounts(ps));
    }).catch(function () { FETCHING = false; });
  }

  // Debounced trigger.
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 80); }

  // 1) Initial.
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // 2) After the AJAX filter swap re-renders the panel (childList + text changes).
  var obs = new MutationObserver(function () { if (!APPLYING) schedule(); });
  obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  // 3) When the shopper toggles any filter (drawer ticks fire change/click here).
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && e.target.name.indexOf('filter.') === 0) schedule();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.bcl-filter-check, [data-bcl-filter-panel], .bcl-filter-panel')) schedule();
  }, true);

  // 4) Timed safety net for late drawer render / slow products.json.
  [400, 1000, 2000].forEach(function (ms) { setTimeout(run, ms); });
})();
